import { Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"

export function RuleSetReferenceSummary({ summary }) {
    if (!summary?.meta && !summary?.preview) return null

    return (
        <Stack spacing={0.25} data-cy="rule-set-reference-content-summary">
            <If value={summary?.meta}>
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", lineHeight: 1.4 }}>
                    {summary?.meta}
                </Typography>
            </If>
            <If value={summary?.preview}>
                <Typography variant="caption" color="text.primary" sx={{ display: "block", lineHeight: 1.4 }}>
                    {summary?.preview}
                </Typography>
            </If>
        </Stack>
    )
}
